import { Menu, useGetIdentity } from 'react-admin';
import { Divider, ListSubheader } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import PaymentsIcon from '@mui/icons-material/Payments';
import SellIcon from '@mui/icons-material/Sell';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import { ActiveCallCard } from './ActiveCallCard';

const ADMIN_EMAIL = 'bram@cleocremation.com';

export const MyMenu = () => {
    const { data: identity } = useGetIdentity();
    const canSeeAdmin = identity?.email === ADMIN_EMAIL;

    return (
        <Menu>
            <Menu.ResourceItem name="funerals" />
            <Menu.ResourceItem name="clients" />
            <Menu.ResourceItem name="contracts" />
            <Menu.ResourceItem name="deliveries" />
            <Menu.Item to="/aftercare" primaryText="Aftercare" leftIcon={<VolunteerActivismIcon />} />
            <Menu.ResourceItem name="leads" />
            <Menu.Item to="/coroner-payments" primaryText="Coroners" leftIcon={<PaymentsIcon />} />
            {/* <Menu.ResourceItem name="articles" /> */}
            <Menu.ResourceItem name="partners" />
            <Menu.ResourceItem name="places" />
            <Menu.ResourceItem name="analytics" />
            <Menu.Item to="/pricing" primaryText="Pricing" leftIcon={<SellIcon />} />
            <Menu.Item to="/seo" primaryText="SEO" leftIcon={<TravelExploreIcon />} />
            <Menu.Item to="/sied" primaryText="SIED" leftIcon={<DescriptionIcon />} />
            {canSeeAdmin && (
                <>
                    <Divider sx={{ my: 1 }} />
                    <ListSubheader disableSticky sx={{ lineHeight: '32px' }}>
                        Admin
                    </ListSubheader>
                    <Menu.Item to="/phase-0" primaryText="Phase 0" leftIcon={<SmartToyIcon />} />
                    <Menu.Item to="/partner-reconciliation" primaryText="Partner Invoices" leftIcon={<ReceiptLongIcon />} />
                    <Menu.Item to="/profitability" primaryText="Profitability" leftIcon={<QueryStatsIcon />} />
                    <Menu.ResourceItem name="quotes" />
                    <Menu.ResourceItem name="settings" />
                    <Menu.ResourceItem name="profiles" />
                    <Menu.ResourceItem name="items" />
                    <Menu.ResourceItem name="taxes" />
                    <Menu.ResourceItem name="sb_payments" />
                </>
            )}
            <ActiveCallCard />
        </Menu>
    );
};
